import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Booking, ChatMessage, PaginatedBookingResponse, RegionsWithId } from '../Models/booking';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(private http:HttpClient) { }
  
    baseurl=`${environment.baseUrl}`
    
 getBookings(pageNumber: number=1, pageSize: number=10, searchText: string = '',bookingStatus?:string,dateFilter?:string,RegionId?:number|string): Observable<PaginatedBookingResponse> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
     
      if(dateFilter){
        params=params.set('dateFilter',dateFilter)
      }

    if (searchText) {
      params = params.set('searchText', searchText);
    }

    if (RegionId) {
      params = params.set('regionId', RegionId);
    }
    if (bookingStatus) {
      params = params.set('bookingStatus', bookingStatus);
    }

    return this.http.get<PaginatedBookingResponse>(`${this.baseurl}/booking/all-bookings`, { params });
  }

  getRegionsWithIds(){
    return this.http.get<RegionsWithId[]>(`${this.baseurl}/content-manager/region-names`);
  }
  getAllChatHistory(user1Id:number,user2Id:number){
    return this.http.get<ChatMessage[]>(`${this.baseurl}/admin/tourist-tourguide-chat-history?User1Id=${user1Id}&User2Id=${user2Id}`)
  }

  getAdminCancellationReasons(): Observable<any> {
    return this.http.get<any>(`${this.baseurl}/admin/booking/cancellation-reasons`);
  }

  getTouristCancellationReasons(): Observable<any> {
    return this.http.get<any>(`${this.baseurl}/tourist/booking/cancellations-reasons`);
  }

  upsertCancellationReason(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseurl}/admin/upsert-reasons`, payload);
  }

  deleteCancellationReason(id: number): Observable<any> {
    return this.http.delete<any>(`${this.baseurl}/admin/delete-reason/${id}`);
  }
}
